<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Detalle del pedido</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  <!-- HELP TOOLTIP (controlado por DOM como lo tenés) -->
  <div class="row m-3 p-3 align-items-center" id="tooltip-pwa">
    <div class="col-auto">
      <i class="bi bi-info-circle" style="font-size: 1.8em;"></i>
    </div>
    <div class="col" id="helpinfo"></div>
    <div class="col-auto" (click)="openhelp()">
      <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
    </div>
  </div>

  <!-- Sections -->
  <div class="row-cols-12 m-2 mt-0">
    <div class="row row-cols-12 mt-0">
      <div class="col-8">
        <div class="text-p p-3 pb-0 nameUser">
          #{{ ordenComercio?.id }}
        </div>

        <div class="text-p p-3 pt-0 pb-2 dateUser">
          <a [routerLink]="[url_perfil]">
            <span style="color:#205EA5">{{ nombre }}</span>
          </a>
        </div>

        <div class="ms-3 pb-0 ps-1 pe-1 rounded order-status">
          <i class="bi bi-check-circle"></i>
          Pedido {{ estado_orden }}
        </div>
      </div>

      <div class="col-4 col-profile">
        <a [routerLink]="[url_perfil]">
          <img
            class="text-end rounded-circle business-profile"
            [src]="preview_img_avatar == '' ? './assets/img/commerce-r-init.png' : preview_img_avatar"
          />
        </a>
      </div>
    </div>

    <hr class="divisor mt-3 mb-1" />

    <div class="text-p p-3 pt-2 locationUser d-flex align-items-center">
      @if (b_envio_domicilio) {
        <span class="pe-0 d-flex align-items-center">
          <i class="bi bi-truck icons-detail pe-1"></i><span>Envío a domicilio</span>
        </span>
      } @else {
        <span class="pe-0 d-flex align-items-center">
          <i class="bi bi-shop icons-detail pe-1"></i><span>Retiro en el local</span>
        </span>
      }

      @if (b_pago_mercadopago) {
        <span class="ps-3 pe-0">
          <img
            src="./assets/img/mercado_pago.png"
            title="Mercado Pago"
            class="icon-mercadopago pe-1"
          />
          <span>MercadoPago</span>
        </span>
      }

      @if (b_pago_efectivo) {
        <span class="ps-3 pe-0 d-flex align-items-center">
          <i class="bi bi-cash-coin icons-detail pe-1"></i>
          <span>Pago en Efectivo</span>
        </span>
      }

      @if (x_img_receta) {
        <span
          class="ps-3 pe-0"
          title="Descargar Receta"
          style="cursor:pointer;"
          (click)="openFile()"
        >
          <i class="bi bi-file-earmark-text"></i>
        </span>
      }
    </div>

    <hr class="divisor mt-0 mb-1" />

    <div class="row-cols-12 mt-0">
      <!-- VADEMECUMS -->
      @for (vademecum of vademecumsOrdenComercio; track vademecum.id_vademecum) {
        <div class="row p-3 pb-2">
          <div class="col-8 col-lg-8">
            <div
              class="text-start title-product"
              [ngClass]="{
                'text-decoration-line-through text-danger': !vademecum.b_activo,
                'text-success': !vademecum.id
              }"
            >
              {{ vademecum.n_cantidad }} x {{ vademecum.x_nombre }}
            </div>

            <div
              class="text-start description-product"
              [ngClass]="{
                'text-decoration-line-through text-danger': !vademecum.b_activo,
                'text-success': !vademecum.id
              }"
            >
              {{ vademecum.nombreLaboratorio }} - {{ vademecum.x_presentacion }}
            </div>
          </div>

          <div class="col-4 col-lg-4">
            <div
              class="text-title-item text-end"
              [ngClass]="{
                'text-success': vademecum.n_precio != vademecum.n_precio_final,
                'text-primary': vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0,
                'text-decoration-line-through text-danger': !vademecum.b_activo
              }"
            >
              <b>
                {{
                  (
                    (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0)
                      ? (vademecum.n_precio_final! * (1 - vademecum.n_porcentaje_descuento / 100))
                      : vademecum.n_precio_final
                  ) | currency:'ARS'
                }}
              </b>
            </div>

            @if (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0) {
              <div class="col-12 text-end d-flex flex-row-reverse">
                <div class="col-auto text-title-item bg-primary text-light discount-shop d-flex w-auto">
                  {{ vademecum.n_porcentaje_descuento }}% OFF
                </div>
              </div>
            }

            @if (vademecum.n_precio != vademecum.n_precio_final || (vademecum.n_porcentaje_descuento && vademecum.n_porcentaje_descuento > 0)) {
              <div class="text-detail-item text-end text-decoration-line-through text-danger">
                <b>{{ vademecum.n_precio | currency:'ARS' }}</b>
              </div>
            }

            @if (vademecum.b_activo && ordenComercio?.id_estado_orden == 2 && id_perfil_usuario != 4) {
              <div class="col-12 col-lg-2 fw-bold text-end">
                <div class="remove-button remove">
                  <i class="align-middle bi bi-dash" title="Quitar 1" (click)="deleteVademecum(vademecum.id_vademecum!)"></i>
                </div>
              </div>
            }
          </div>

          <hr class="divisor mt-4 mb-1" />
        </div>
      }

      <!-- PRODUCTOS -->
      @for (producto of productosOrdenComercio; track producto.id_producto) {
        <div class="row p-3 pb-2">
          <div class="col-8">
            <div
              class="text-start title-product"
              [ngClass]="{
                'text-decoration-line-through text-danger': !producto.b_activo,
                'text-success': !producto.id
              }"
            >
              {{ producto.n_cantidad }} x {{ producto.x_nombre }}
            </div>

            <div
              class="d-flex text-start description-product"
              [ngClass]="{
                'text-decoration-line-through text-danger': !producto.b_activo,
                'text-success': !producto.id
              }"
            >
              SKU: {{ producto.x_sku }}
            </div>
          </div>

          <div class="col-4">
            <div
              class="col-12 text-title-item text-end"
              [ngClass]="{
                'text-success': producto.n_precio != producto.n_precio_final,
                'text-primary': producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0,
                'text-decoration-line-through text-danger': !producto.b_activo
              }"
            >
              <b>
                {{
                  (
                    (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0)
                      ? (producto.n_precio_final! * (1 - producto.n_porcentaje_descuento / 100))
                      : producto.n_precio_final
                  ) | currency:'ARS'
                }}
              </b>
            </div>

            @if (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0) {
              <div class="col-12 text-end d-flex flex-row-reverse">
                <div class="col-auto text-title-item bg-primary text-light discount-shop d-flex w-auto">
                  {{ producto.n_porcentaje_descuento }}% OFF
                </div>
              </div>
            }

            @if (producto.n_precio != producto.n_precio_final || (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0)) {
              <div class="col-12 text-detail-item text-decoration-line-through text-danger text-end">
                <b>{{ producto.n_precio | currency:'ARS' }}</b>
              </div>
            }

            @if (producto.b_activo && ordenComercio?.id_estado_orden == 2 && id_perfil_usuario != 4) {
              <div class="col-12 text-end">
                <div class="remove-button remove">
                  <i class="align-middle bi bi-dash" title="Quitar 1" (click)="deleteProducto(producto.id_producto!)"></i>
                </div>
              </div>
            }
          </div>

          <hr class="divisor mt-4 mb-1" />
        </div>
      }

      <!-- ENVIO -->
      @if (b_envio_domicilio) {
        <div class="row p-3 pb-2">
          <div class="col-6 col-lg-6">
            <div class="text-start title-product">Valor del envío</div>
            <div class="text-start description-product">Hasta el domicilio</div>
          </div>

          <div class="col-6 col-lg-6 fw-bold fieldInfo text-end">
            <div class="col-auto">
              {{ n_precio_envio | currency:'ARS' }}
            </div>

            @if (ordenComercio?.id_estado_orden == 2 && id_perfil_usuario != 4) {
              <div class="col-2 col-sm-2 ms-2">
                <div class="remove-button remove" (click)="deleteEnvio()" title="Quitar envío">
                  <i class="align-middle bi bi-dash"></i>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="row p-3 pb-2">
          <div class="col-7 col-lg-10">
            <div class="text-start title-product">Tiempo de envío</div>
            <div class="text-start description-product">Mins. estimados hasta el domicilio</div>
          </div>

          <div class="col-5 col-lg-2 fw-bold fieldInfo text-end">
            {{ n_tiempo_envio }} mins
          </div>
        </div>
      }
    </div>

    @if (b_envio_domicilio) {
      <hr class="divisor mt-3 mb-0" />
    }

    <!-- TOTALES -->
    <div class="row-cols-12 mt-2 mb-2">
      @if (n_ahorro > 0) {
        <div class="row p-3 pb-0">
          <div class="col col-lg-9 fw-bold text-start">Subtotal</div>
          <div class="col-auto col-lg-3 fw-bold text-end">{{ n_total | currency:'ARS' }}</div>
        </div>

        <div class="row p-3 pb-0">
          <div class="col col-lg-9 fw-bold text-start">Ahorro</div>
          <div class="col-auto col-lg-3 fw-bold text-end text-success">-{{ n_ahorro | currency:'ARS' }}</div>
        </div>
      }

      <div class="row p-3 pb-0">
        <div class="col col-lg-9 fw-bold title-total text-start">Total</div>

        @if (n_ahorro <= 0) {
          <div class="col-auto col-lg-3 fw-bold title-total text-end">{{ n_total | currency:'ARS' }}</div>
        } @else {
          <div class="col-auto col-lg-3 fw-bold title-total text-end">{{ (n_total - n_ahorro) | currency:'ARS' }}</div>
        }
      </div>
    </div>

    <!-- NOTAS -->
    <div class="row-cols-12 mt-0">
      <div class="row p-3 pb-0">
        <div class="col col-lg-10 fw-bold titleQuestion text-truncate">
          <b>Notas</b>
        </div>
      </div>

      <div class="row p-4 pb-0 pt-2">
        <textarea class="add-notes" rows="2" [(ngModel)]="x_notas" name="x_notas" disabled readonly></textarea>
      </div>
    </div>

    <hr class="divisor mt-3 mb-1" />
  </div>

  <div [hidden]="error.length == 0" class="alert alert-danger mt-2" role="alert">
    <small>{{ error }}</small>
  </div>

  <!-- ACCIONES -->
  <div class="d-grid mt-0 mb-2 pb-3 mb-3 align-items-center">
    <div class="row d-flex justify-content-center mt-1">
      <div class="col d-flex justify-content-evenly">
        @if (id_estado_orden != 4 && id_estado_orden != 5 && id_estado_orden != 6 && id_estado_orden != 9 && id_perfil_usuario != 4) {
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2 cancel-order"
            [disabled]="loading"
            (click)="cancelarOrderComercio()"
          >
            <i class="bi bi-x-circle"></i> &nbsp; {{ loading ? 'Cargando...' : 'Cancelar pedido' }}
          </button>
        }

        @if (id_estado_orden == 2 && b_pago_efectivo && id_perfil_usuario != 4) {
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2 approve-order"
            [disabled]="loading"
            (click)="confirmarOrderComercio()"
          >
            <i class="bi bi-check2-circle"></i> &nbsp; {{ loading ? 'Cargando...' : 'Confirmar pedido' }}
          </button>
        }

        @if ((id_estado_orden == 2 || id_estado_orden == 3 || id_estado_orden == 7 || id_estado_orden == 8) && b_pago_mercadopago && id_perfil_usuario != 4) {
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2 approve-order"
            [disabled]="loading"
            (click)="pagarOrderComercio()"
          >
            <i class="bi bi-check2-circle"></i> &nbsp; {{ loading ? 'Cargando...' : 'Pagar pedido' }}
          </button>
        }

        @if ((id_estado_orden == 3 || id_estado_orden == 6) && id_perfil_usuario == 4) {
          <button
            type="button"
            class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2 approve-order"
            [disabled]="loading"
            (click)="entregadoOrderComercio()"
          >
            <i class="bi bi-check2-circle"></i> &nbsp; {{ loading ? 'Cargando...' : 'Entregado' }}
          </button>
        }
      </div>
    </div>

    <div class="row d-flex justify-content-center mt-1">
      <div class="col d-flex justify-content-evenly">
        @if (id_estado_orden == 4 && id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/review-comercio/' + id]">
            <i class="bi bi-chat"></i> &nbsp; Calificar pedido
          </button>
        }

        @if (id_estado_orden == 9 && id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/review-comercio/' + id]">
            <i class="bi bi-chat"></i> &nbsp; Ver tu opinion
          </button>
        }

        @if ((id_estado_orden == 4 || id_estado_orden == 9) && id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/comercio']">
            Repetir pedido
          </button>
        }

        @if (id_perfil_usuario != 4) {
          <button type="button" class="btn btn-primary btn-lg mt-0 btnOpt fade-in p-2" [routerLink]="['/ayuda']">
            Ayuda
          </button>
        }
      </div>
    </div>
  </div>
</div>